<template>
  <div class="list-page">
    <div class="detail-banner">
      <div class="container">
        <h1>{{ title }}</h1>
      </div>
    </div>

    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div v-if="loading" class="empty-block">加载中…</div>

        <div v-else-if="items.length" class="os-item-grid">
          <div
            v-for="(it, i) in items"
            :key="i"
            class="os-item-card"
            @click="openItem(it)"
          >
            <img v-if="it.image" :src="it.image" class="os-item-icon" @error="onImgError" />
            <span v-else class="os-item-ph">{{ it.title.slice(0, 1) }}</span>
            <div class="os-item-text">
              <div class="os-item-title">{{ it.title }}</div>
              <div class="os-item-sub">{{ it.subtitle }}</div>
            </div>
            <span class="os-item-arrow"></span>
          </div>
        </div>

        <div v-else class="empty-block">该服务内容整理中，敬请期待</div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchOverseaService } from '../api/home'

export default {
  name: 'OverseaServiceList',
  data () {
    return {
      items: [],
      title: '平台自营服务',
      loading: true
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        const list = await fetchOverseaService()
        const cat = list[Number(this.$route.params.cat)] || {}
        this.title = cat.title || '平台自营服务'
        this.items = cat.data || []
      } catch (e) {
        this.items = []
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    openItem (it) {
      if (!it.json) {
        this.$toast.show({ message: '该服务内容整理中，敬请期待', type: 'info' })
        return
      }
      this.$router.push({
        path: '/oversea-service-info',
        query: { json: it.json, title: it.title }
      })
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.os-item-grid {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
}
.os-item-card {
  display: flex;
  align-items: center;
  gap: 18px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: var(--shadow);
  padding: 22px 24px;
  cursor: pointer;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.os-item-card:hover {
  box-shadow: var(--shadow-hover);
  transform: translateY(-2px);
}
.os-item-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  object-fit: contain;
  background: var(--blue-soft);
  flex-shrink: 0;
}
.os-item-ph {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: var(--primary);
  color: #fff;
  font-size: 24px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.os-item-text {
  flex: 1;
  min-width: 0;
}
.os-item-title {
  font-size: 18px;
  font-weight: 800;
  color: var(--text-main);
}
.os-item-sub {
  font-size: 13.5px;
  color: var(--text-sub);
  margin-top: 6px;
}
.os-item-arrow {
  width: 12px;
  height: 12px;
  border-top: 3px solid var(--primary);
  border-right: 3px solid var(--primary);
  transform: rotate(45deg);
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .os-item-grid {
    grid-template-columns: 1fr;
  }
}
</style>
